module.exports = __webpack_public_path__ + "img/IMG-20200301-WA0303.4dfc2ca8.jpg";